import React, { useEffect, useState, useRef } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import Popup from 'reactjs-popup'
import Pill from 'srcReact/components/common2/Pill'
import Button from 'srcReact/components/common2/Button'
import { TextBox } from 'srcReact/components/common2/TextBox'
import { commonActions } from 'srcReact/components/actions'
import ToggleSwitch from 'srcReact/components/common2/ToggleSwitch'
import { profileActions } from '../../../../../../action'
import HistoryTree from '../../../HistoryTree'
import LanguagePopup from '../LanguagePopup'
import JourneyPopup from '../JourneyPopup'
import styles from './styles.module.scss'
import Icon from 'srcReact/components/icons/Icon'
import PromptBlock from '../../../PromptBlock'
import UpdateInterestModal from '../UpdateInterestModal'
import { getCurrentOrgId } from 'srcReact/helpers/organizationHelper'
import { organizationActions } from 'srcReact/OrganizationPage'
import { TextArea } from 'srcReact/components/common2/TextArea'

export default function InfoBlock() {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const descRef = useRef(null)

  const {
    myProfile: {
      profileData,
      languagePopup,
      profileDetailsUpdated,
      userEducation,
      userExperience,
      userInterests,
      userExpertise,
      profileData: { user }
    }
  } = useSelector((state) => state)
  const { loggedIn } = useSelector((state) => state.login)
  const { languages, isNative } = useSelector((state) => state.common)

  const interestsPublic = profileData.user.is_display_ci === '1' ? true : false
  useEffect(() => {
    const logged = loggedIn ? 1 : 0
    dispatch(commonActions.getLanguages(logged))
    if (descRef?.current) {
      descRef.current.focus()
    }
  }, [])

  const [parentInputRef, setParentInputRef] = useState(null)
  const [nativeInputRef, setNativeInputRef] = useState(null)
  const [cityInputRef, setCityInputRef] = useState(null)
  const [colorInputRef, setColorInputRef] = useState(null)
  const [sportsInputRef, setSportsInputRef] = useState(null)

  const [aboutBtn, setAboutBtn] = useState(false)
  const [cityBtn, setCityBtn] = useState(false)
  const [nativeBtn, setNativeBtn] = useState(false)
  const [colorBtn, setColorBtn] = useState(false)
  const [teamBtn, setTeamBtn] = useState(false)
  const [parentBtn, setParentBtn] = useState(false)
  const [aboutDesc, setAboutDesc] = useState({
    name: 'message',
    value: '',
    hasError: false,
    errorMessage: '',
    isRequired: false
  })
  const [cities, setCities] = useState('')
  const [native, setNative] = useState('')
  const [color, setColor] = useState('')
  const [animal, setAnimal] = useState('')
  const [sportsTeam, setSportsTeam] = useState('')
  const [children, setChildren] = useState('')
  const [languageOptions, setLanguageOptions] = useState('')
  const [interestType, setInterestType] = useState('')
  const [isInterestModalOpen, setIsInterestModalOpen] = useState(false)
  const [modalType, setModalType] = useState('')
  const [bioUpdateTriggred, setBioUpdateTriggred] = useState(false)
  const typeExperience = 'experience'
  const typeEducation = 'education'

  useEffect(() => {
    setAboutDesc({ ...aboutDesc, value: profileData.user.about_me })
    setCities({ ...cities, value: profileData.user.city })
    setNative({ ...native, value: profileData.user.originally_from })
    setColor({ ...color, value: profileData.user.favorite_color })
    setAnimal({ ...cities, value: profileData.user.totem_animal })
    setSportsTeam({ ...sportsTeam, value: profileData.user.favorite_sport_team })
    setChildren({ ...children, value: profileData.user.children })
    if (bioUpdateTriggred && !profileDetailsUpdated.loading && profileDetailsUpdated.updated) {
      setBioUpdateTriggred(false)
      callHeaderInfoForNative() //to update myprofile ctas
    }
  }, [profileData.user, bioUpdateTriggred, profileDetailsUpdated.loading])

  const callHeaderInfoForNative = () => {
    if (isNative) {
      const organizationId = getCurrentOrgId()
      dispatch(organizationActions.getHeaderInfo(organizationId))
    }
  }

  const convertLangToData = () => {
    let options =
      languages &&
      languages.map((l, index) => {
        return {
          value: l.code,
          label: l.name
        }
      })
    setLanguageOptions(options)
    return
  }

  const handleAbout = (e) => {
    setAboutBtn(true)
    setAboutDesc({
      ...aboutDesc,
      value: e.target.value
    })
  }

  const handleToggle = (key, value) => {
    const isPublic = value ? '1' : '0'
    const payload = {
      key,
      value: isPublic
    }
    dispatch(profileActions.putProfileDetails(payload.key, payload.value))
  }

  const handleCity = (e) => {
    setCityBtn(true)
    setCities({
      ...cities,
      value: e.target.value
    })
  }

  const handleNative = (e) => {
    setNativeBtn(true)
    setNative({
      ...native,
      value: e.target.value
    })
  }

  const handleColor = (e) => {
    setColorBtn(true)
    setColor({
      ...color,
      value: e.target.value
    })
  }

  const handleTeam = (e) => {
    setTeamBtn(true)
    setSportsTeam({
      ...sportsTeam,
      value: e.target.value
    })
  }

  const handleChildren = (e) => {
    setParentBtn(true)
    setChildren({
      ...children,
      value: e.target.value
    })
  }

  const handleSubmit = (key, valueObj) => {
    setAboutBtn(false)
    setCityBtn(false)
    setNativeBtn(false)
    setColorBtn(false)
    setTeamBtn(false)
    setParentBtn(false)
    const payload = {
      key,
      value: valueObj.value
    }
    parentInputRef.current.blur()
    cityInputRef.current.blur()
    colorInputRef.current.blur()
    nativeInputRef.current.blur()
    sportsInputRef.current.blur()
    if (key === 'about_me') {
      setBioUpdateTriggred(true)
    }
    dispatch(profileActions.putProfileDetails(payload.key, payload.value))
  }

  const addLanguage = () => {
    dispatch(profileActions.setLanguagePopup(true))
    convertLangToData()
  }

  const addExperience = () => {
    setModalType(typeExperience)
  }

  const addEducation = () => {
    setModalType(typeEducation)
  }

  const closeJourneyModal = () => {
    setModalType('')
  }

  const openInterestModal = (type) => {
    if (type === 'expertise') {
      setInterestType('expertise')
    } else if (type === 'interest') {
      setInterestType('interest')
    }
    setIsInterestModalOpen(true)
  }

  const closeInterestModal = () => {
    setIsInterestModalOpen(false)
    setInterestType('')
  }

  // let sortedPrompts = []
  // if (user?.prompts?.prompts?.length >= 1) {
  //   sortedPrompts = user?.prompts?.prompts?.slice().sort((a, b) => b.id_prompt_user - a.id_prompt_user)
  // }

  return (
    <div className={`${styles.infoContainer}`}>
      <h2 className={`${styles.aboutTitle}`}>{t('my_profile.info_block_edit.aboutMe')}</h2>
      <h2 className={`${styles.sectionSubText}`}>{t('my_profile.info_block_edit.interests_subtext_5')}</h2>
      <div className={`${styles.aboutDesc}`}>
        <TextArea
          rows={4}
          isRequired={false}
          fieldInfo={aboutDesc}
          placeholder={t('my_profile.info_block.about_empty_placeholder')}
          onChange={handleAbout}
          customWrapperCss={styles.aboutIp}
        />
      </div>
      {aboutBtn ? (
        <div className={`${styles.buttonWrap}`}>
          <Button
            text={t('my_profile.info_block.update')}
            handleClick={() => handleSubmit('about_me', aboutDesc)}
            size='large'
          />
        </div>
      ) : (
        ''
      )}
      <div className={`${styles.titleWrap}`}>
        <h2 className={`${styles.sectionTitle}`}>{t('my_profile.info_block_edit.myInterests')}</h2>
        <div className={`${styles.toggleWrap}`}>
          <h2>{t('my_profile.popup.public')}</h2>
          <ToggleSwitch
            isChecked={interestsPublic}
            height={16}
            onChange={() => handleToggle('is_display_ci', !interestsPublic)}
          />
        </div>
      </div>
      <h2 className={`${styles.sectionSubText}`}>{t('my_profile.info_block_edit.interests_subtext_1')}</h2>
      <div className={`${styles.pillWrapper} ${styles.interestPillWrapper}`}>
        <button className={styles.addPill} onClick={() => openInterestModal('interest')}>
          <div className={styles.iconPill}>
            <Icon name='add' size='large' />
          </div>
          <h2>{t('my_profile.info_block_edit.interest_add_edit')}</h2>
        </button>
        {userInterests.list?.length > 0 && (
          <div className={styles.interests}>
            {userInterests.list.map((interest) => (
              <Pill type='interest' selected={true} text={interest.name} />
            ))}
          </div>
        )}
      </div>

      <h2 className={`${styles.sectionTitle}`}>{t('my_profile.info_block_edit.expertises')}</h2>
      <div className={`${styles.pillWrapper} ${styles.interestPillWrapper}`}>
        <button className={styles.addPill} onClick={() => openInterestModal('expertise')}>
          <div className={styles.iconPill}>
            <Icon name='add' size='large' />
          </div>
          <h2>{t('my_profile.info_block_edit.expertise_add_edit')}</h2>
        </button>
        {userExpertise?.list?.length > 0 && (
          <div className={styles.interests}>
            {userExpertise.list.map((i) => (
              <Pill type='expertise' selected={true} text={i.name} />
            ))}
          </div>
        )}
      </div>

      <PromptBlock user={user} title={t('my_profile.myPrompts.title')} block='myProfile' />

      <h2 className={`${styles.sectionTitle}`}>{t('my_profile.info_block_edit.myJourney')}</h2>
      <h2 className={`${styles.sectionSubText}`}>{t('my_profile.info_block_edit.interests_subtext_4')}</h2>
      <button className={styles.addPill} onClick={addExperience}>
        <div className={styles.iconPill}>
          <Icon name='add' size='large' />
        </div>
        {userExperience.list && userExperience.list.length > 0 ? (
          <h2>{t('my_profile.info_block_edit.experience_add_edit')}</h2>
        ) : (
          <h2>{t('my_profile.info_block_edit.experience_add')}</h2>
        )}
      </button>
      {userExperience.list && userExperience.list.length > 0 && (
        <HistoryTree treeType={'experiences'} expData={userExperience.list} />
      )}

      <h2 className={`${styles.sectionTitle}`}>{t('my_profile.info_block_edit.myEducation')}</h2>
      <button className={styles.addPill} onClick={addEducation}>
        <div className={styles.iconPill}>
          <Icon name='add' size='large' />
        </div>
        {userEducation.list && userEducation.list.length > 0 ? (
          <h2>{t('my_profile.info_block_edit.education_add_edit')}</h2>
        ) : (
          <h2>{t('my_profile.info_block_edit.education_add')}</h2>
        )}
      </button>
      {userEducation.list && userEducation.list.length > 0 && (
        <HistoryTree treeType={'education'} expData={userEducation.list} />
      )}
      <h2 className={`${styles.sectionTitle}`}>{t('my_profile.info_block_edit.languages')}</h2>
      {profileData.user && profileData.user.languages && profileData.user.languages.length === 0 ? (
        <button className={styles.addPill} onClick={addLanguage}>
          <div className={styles.iconPill}>
            <Icon name='add' size='large' />
          </div>
          <h2>{t('my_profile.info_block_edit.languages_add')}</h2>
        </button>
      ) : (
        <div className={`${styles.pillWrapper}`}>
          {profileData.user &&
            profileData.user.languages &&
            profileData.user.languages.map((i) => <Pill className={styles.pill} text={i.name} />)}
          <button
            aria-label={t('my_profile.info_block_edit.languages_add')}
            className={`${styles.addButton}`}
            onClick={addLanguage}>
            <div className={styles.iconPill}>
              <Icon name='add' size='large' />
            </div>
          </button>
        </div>
      )}

      <h2 className={`${styles.sectionTitle}`}>{t('my_profile.info_block_edit.city')}</h2>
      <div className={`${styles.inputBlock}`}>
        <TextBox
          customWrapperCss={styles.inputWrap}
          customInputCss={styles.input}
          fieldInfo={cities}
          setRef={setCityInputRef}
          onChange={handleCity}
          placeholder={t('my_profile.info_block_edit.city_pl')}
        />
        {cityBtn ? (
          <Button
            text={t('my_profile.info_block.update')}
            handleClick={() => handleSubmit('city', cities)}
            size='large'
          />
        ) : (
          ''
        )}
      </div>

      <h2 className={`${styles.sectionTitle}`}>{t('my_profile.info_block_edit.native')}</h2>
      <div className={`${styles.inputBlock}`}>
        <TextBox
          customWrapperCss={styles.inputWrap}
          customInputCss={styles.input}
          fieldInfo={native}
          setRef={setNativeInputRef}
          onChange={handleNative}
          placeholder={t('my_profile.info_block_edit.native_pl')}
        />
        {nativeBtn ? (
          <Button
            text={t('my_profile.info_block.update')}
            handleClick={() => handleSubmit('originally_from', native)}
            size='large'
          />
        ) : (
          ''
        )}
      </div>

      <h2 className={`${styles.sectionTitle}`}>{t('my_profile.info_block_edit.parent')}</h2>
      <div className={`${styles.inputBlock}`}>
        <TextBox
          customWrapperCss={styles.childInputWrap}
          customInputCss={styles.input}
          fieldInfo={children}
          setRef={setParentInputRef}
          onChange={handleChildren}
          type='number'
          placeholder={t('my_profile.info_block_edit.parent_pl')}
        />
        <h2 className={`${styles.subText}`}>{t('my_profile.info_block_edit.children')}</h2>
        {parentBtn ? (
          <Button
            text={t('my_profile.info_block.update')}
            handleClick={() => handleSubmit('children', children)}
            size='large'
          />
        ) : (
          ''
        )}
      </div>

      <h2 className={`${styles.sectionTitle}`}>{t('my_profile.info_block_edit.color')}</h2>
      <div className={`${styles.inputBlock}`}>
        <TextBox
          customWrapperCss={styles.inputWrap}
          customInputCss={styles.input}
          fieldInfo={color}
          setRef={setColorInputRef}
          onChange={handleColor}
          placeholder={t('my_profile.info_block_edit.color_pl')}
        />
        {colorBtn ? (
          <Button
            text={t('my_profile.info_block.update')}
            handleClick={() => handleSubmit('favorite_color', color)}
            size='large'
          />
        ) : (
          ''
        )}
      </div>

      <h2 className={`${styles.sectionTitle}`}>{t('my_profile.info_block_edit.sports_team')}</h2>
      <div className={`${styles.inputBlock}`}>
        <TextBox
          customWrapperCss={styles.inputWrap}
          customInputCss={styles.input}
          fieldInfo={sportsTeam}
          setRef={setSportsInputRef}
          onChange={handleTeam}
          placeholder={t('my_profile.info_block_edit.sports_team_pl')}
        />
        {teamBtn ? (
          <Button
            text={t('my_profile.info_block.update')}
            handleClick={() => handleSubmit('favorite_sport_team', sportsTeam)}
            size='large'
          />
        ) : (
          ''
        )}
      </div>
      <Popup
        open={languagePopup}
        onClose={() => dispatch(profileActions.setLanguagePopup(false))}
        modal
        overlayStyle={{ background: 'rgba(54, 73, 88, 0.4)' }}
        contentStyle={{
          width: '95%',
          maxWidth: '500px',
          padding: '0px',
          borderRadius: '22px',
          boxShadow: '5px 2px 10px 0 rgba(14, 11, 40, 0.15)',
          background: 'white',
          border: 'none'
        }}>
        <LanguagePopup options={languageOptions} />
      </Popup>
      {modalType === typeExperience ? (
        <JourneyPopup isOpen={modalType === typeExperience} type={typeExperience} closeModal={closeJourneyModal} />
      ) : null}

      {modalType === typeEducation ? (
        <JourneyPopup isOpen={modalType === typeEducation} type={typeEducation} closeModal={closeJourneyModal} />
      ) : null}

      {isInterestModalOpen && interestType ? (
        <UpdateInterestModal interestType={interestType} isOpen={isInterestModalOpen} closeModal={closeInterestModal} />
      ) : null}
    </div>
  )
}
